import { useEffect, useState } from "react";
import { api, uploadMedia } from "../../lib/api";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { HeroContentForm } from "./content/HeroContentForm";
import { ContactContentForm } from "./content/ContactContentForm";
import { SocialContentForm } from "./content/SocialContentForm";
import { ServiceEditItem } from "./content/ServiceEditItem";

export const AdminContent = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);
  const [uploadingKey, setUploadingKey] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data));
  }, []);

  const update = (field, value) => setContent((c) => ({ ...c, [field]: value }));
  const updateService = (idx, field, value) =>
    setContent((c) => {
      const services = [...c.services];
      services[idx] = { ...services[idx], [field]: value };
      return { ...c, services };
    });

  const handleHeroUpload = async (e, field) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingKey(field);
    try {
      const { url } = await uploadMedia(file, "image");
      update(field, url);
      toast.success("Foto principal subida");
    } catch {
      toast.error("Error al subir la foto");
    } finally {
      setUploadingKey(null);
      e.target.value = "";
    }
  };

  const handleServiceUpload = async (e, idx, key) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingKey(key);
    try {
      const { url } = await uploadMedia(file, "image");
      updateService(idx, "image", url);
      toast.success("Foto de servicio subida");
    } catch {
      toast.error("Error al subir la foto");
    } finally {
      setUploadingKey(null);
      e.target.value = "";
    }
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", content);
      toast.success("Contenido actualizado");
    } catch {
      toast.error("Error al guardar contenido");
    } finally {
      setSaving(false);
    }
  };

  if (!content) return <p className="text-muted-foreground">Cargando...</p>;

  return (
    <div className="space-y-6" data-testid="admin-content-panel">
      <HeroContentForm content={content} update={update} uploadingKey={uploadingKey} onHeroUpload={handleHeroUpload} />
      <ContactContentForm content={content} update={update} />
      <SocialContentForm content={content} update={update} />

      <Card className="p-6 space-y-6">
        <h3 className="font-semibold">Servicios</h3>
        {content.services.map((s, idx) => (
          <ServiceEditItem
            key={s.key}
            service={s}
            onDescriptionChange={(e) => updateService(idx, "description", e.target.value)}
            onImageChange={(e) => updateService(idx, "image", e.target.value)}
            uploadingKey={uploadingKey}
            onUpload={(e) => handleServiceUpload(e, idx, s.key)}
          />
        ))}
      </Card>

      <Button data-testid="admin-content-save-button" onClick={save} disabled={saving}>
        {saving ? "Guardando..." : "Guardar contenido"}
      </Button>
    </div>
  );
};
